/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />
/// <reference path="../../components/baseclasses/dataMaintenanceContextBase.ts" />

module Meevo.Plugins.EmmaAccountSettings {
    
    import ModalTranslationModes = Meevo.Components.Modal.ModalTranslationModes;
    import DataMaintenanceSection = Meevo.Components.BaseClasses.IDataMaintenanceSection;
    "use strict";

    export class EmmaAccountSettingsContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {

        mode: Meevo.Model.MaintenanceFormState;

        public auditNoun: Meevo.Model.NounEnum;
        protected securityKeys = Meevo.Components.Common.SecurityKeys;
        protected securityParts = Meevo.Components.Common.SecurityParts;

        protected addSecurityKey: string;
        protected editSecurityKey: string;
        public savedAccount: Meevo.Model.EmailMarketingSettings = null;
        
        public advancedMarketingPortalUrl = "";
        public showEmmaSyncToggle: boolean = false;
        public showAccountId: boolean = false;
        
        public account: Meevo.Model.EmailMarketingSettings = <Meevo.Model.EmailMarketingSettings>{};

        public customButtonsSet: Array<Meevo.Components.Controls.IMaintenanceFormCustomButton>;
        window: ng.IWindowService;

        public showSyncOptionsModal: boolean = null;
        public showSyncOptionsReminder: boolean = null;
        public previewCount: number = -1;

        public showSmsUsageCredit = true;
        public hasAlaCarteSmsPlan = false;

        public smsUsageCredit: Meevo.Model.MarketingSmsUsageCredit = <Meevo.Model.MarketingSmsUsageCredit>{};

        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected $translate: angular.translate.ITranslateService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            $window: angular.IWindowService
        ) {
            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);
            this.baseEndpoint = appSettings.API_ENDPOINTS.basicEmailMarketing;
            this.sectionTemplatePath = 'app/plugins/emmaAccountSettings/sectionViews/';
            this.window = $window;
            this.trackingService = trackingService;
            this.buildCrudSecurityKeys(this.securityKeys.MARKETING_EMMA);
            this.advancedMarketingPortalUrl = this.identityService.current().systemSettings.advancedMarketingPortalUrl;
            this.auditNoun = Meevo.Model.NounEnum.AdvancedMarketing;
            this.mode = Meevo.Model.MaintenanceFormState.Readonly;     
            
            this.dataService.customMethodData("api/EmailMarketing/Account", "GET", null).then((res) => {
                if (typeof (res.data) === "object" && res.data !== null) {
                    console.log('got email marketing account', res);
                    if (res.data.accountId) {
                        res.data.accountId = Number(res.data.accountId);
                    }

                    this.account.accountId = res.data.accountId;
                    this.account.syncStatus = res.data.objectStateEnum == Meevo.Model.ObjectStateEnum.Active;
                    this.account.locationLevelSubaccount = res.data.locationLevelSubaccount;
                    this.account.yearThreshold = res.data.yearThreshold;
                    this.account.includeInactive = res.data.includeInactive;
                    this.account.isTFNVerificationSubmitted = res.data.isTFNVerificationSubmitted;
                    this.account.dateTFNVerificationSubmitted = res.data.dateTFNVerificationSubmitted;
                    this.savedAccount = angular.copy(this.account);

                    if (res.data.objectStateEnum != Meevo.Model.ObjectStateEnum.Inactive) {
                        if (this.identityService.inCentralOfficeMode()) {
                            this.showEmmaSyncToggle = !this.account.locationLevelSubaccount;
                        } else {
                            this.showEmmaSyncToggle = this.account.locationLevelSubaccount || this.identityService.current().isSingleLocation;
                        }
                    }

                }
                this.initDisplayOptions();
            }).catch(e => console.log('error getting account id', e));

            //this.initializeSections();
            this.selectSection(this.sections[0]);


            this.customButtonsSet = [
                {
                    text: 'LABEL_EDIT',
                    clickHandler: () => {
                        this.edit();
                    },
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => (this.mode === Meevo.Model.MaintenanceFormState.Readonly),
                    securityRules: this.securityKeys.MARKETING_EMMA + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                    position: 'right'
                },
                {
                    text: 'LABEL_SAVE',
                    clickHandler: () => {
                        this.save();
                    },
                    classNames: 'meevo-button margin-right-2',
                    disableRules: () => false,
                    visibilityRules: () => (this.mode === Meevo.Model.MaintenanceFormState.Editing),
                    securityRules: this.securityKeys.MARKETING_EMMA + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                    position: 'right'
                },
                {
                    text: 'LABEL_CANCEL',
                    clickHandler: () => {
                        this.cancel();
                    },
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => (this.mode === Meevo.Model.MaintenanceFormState.Editing),
                    securityRules: this.securityKeys.MARKETING_EMMA + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                    position: 'right'
                }
            ];

            let entity: any = {
                tenantId: this.identityService.current().tenantId,
                locationId: this.identityService.current().locationId
            };

            this.dataService.customMethodData("api/SmsMarketing/SmsUsageCredit", "POST", entity).then((res) => {
                if (typeof (res.data) === "object" && res.data !== null) {
                    console.log('got sms usage credit', res);

                    this.smsUsageCredit.displayName = res.data.displayName;
                    this.smsUsageCredit.totalUsage = res.data.totalUsage;
                    this.smsUsageCredit.totalCount = res.data.totalCount;

                    if (this.smsUsageCredit.totalCount == 0) {
                        this.hasAlaCarteSmsPlan = true;
                    }
                }
                else {
                    this.showSmsUsageCredit = false;
                }
            }).catch(e => console.log('error getting sms usage credit', e));
        }

        determineSyncToggleVisibility(): boolean {
            return (this.account.locationLevelSubaccount && !this.identityService.inCentralOfficeMode())
                || (!this.account.locationLevelSubaccount && this.identityService.inCentralOfficeMode())
                || (this.identityService.current().isSingleLocation);
        }

        initDisplayOptions(): void {
            this.showSyncOptionsModal = this.isMSIUser() &&
                (this.identityService.current().isSingleLocation ||
                this.identityService.inCentralOfficeMode() ||
                    this.account.locationLevelSubaccount)

            this.showSyncOptionsReminder = this.isMSIUser() &&
                !this.identityService.current().isSingleLocation &&
                !this.identityService.inCentralOfficeMode() &&
                !this.account.locationLevelSubaccount;

            this.showAccountId = !(this.identityService.inCentralOfficeMode() && this.account.locationLevelSubaccount);
        }

        initializeSections(): void {

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MARKETING_EMMA +
                Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new MainSection(0,
                    "SECTION_MAIN",
                    "main.html",
                    true,
                    true,
                    this.baseEndpoint,
                    "BasicMarketing/GetAccountId",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.AdvancedMarketingPage,
                    this.appSettings,
                    this.securityKeys.MARKETING_EMMA +
                    Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            this.selectSection(this.sections[0]);
        }

        initializeHeader(model: any): void {
        }
        
        edit(): void {
            
            this.mode = Meevo.Model.MaintenanceFormState.Editing;
            this.usageTrackingLog(Meevo.Model.VerbEnum.Updated, null);
        }

        save(): angular.IPromise<any> {
                
            if (this.account.syncStatus != this.savedAccount.syncStatus) {
                var thisMessage: string;
                var theseOptions: Meevo.Components.Modal.ILocalOptions = {};

                if (this.account.syncStatus) {
                    thisMessage = this.$translate.instant("LABEL_EMMA_SYNC_ON_WARNING", { yearThreshold: this.account.yearThreshold });
                    theseOptions = {
                        modalClass: 'modal-alert'
                        
                    };
                } else {
                    thisMessage = this.$translate.instant("LABEL_EMMA_SYNC_OFF_WARNING")
                    theseOptions = {
                        modalClass: 'modal-warning'
                    };
                }

                this.modalService.confirm(thisMessage, Components.Modal.ModalTranslationModes.Translate, false, theseOptions).then((res) => {
                    if (res) {
                        return this.sendUpdate();
                    }
                });
            } else if (this.isMSIUser()) {
                var confirmMessage;
                if (this.account.locationLevelSubaccount !== this.savedAccount.locationLevelSubaccount) {
                    if (this.account.locationLevelSubaccount) {
                        confirmMessage = "LABEL_EMMA_ACCOUNT_SAVE_CONFIRM_LOCATION_MODEL";
                    } else {
                        confirmMessage = "LABEL_EMMA_ACCOUNT_SAVE_CONFIRM_CO_MODEL";
                    }
                } else {
                    confirmMessage = "LABEL_EMMA_ACCOUNT_SAVE_CONFIRM";
                }

                this.modalService.confirm(this.$translate.instant(confirmMessage), Components.Modal.ModalTranslationModes.Translate, false, { modalClass: 'modal-warning' }).then((res) => {
                    if (res) {
                        return this.sendUpdate();
                    }
                });
            } else {
                this.cancel();
                return null;
            }
            
        }

        isMSIUser() : boolean {
            return this.identityService.current().userTypeEnum === Model.UserTypeEnum.MSIUser;
        }

        sendUpdate(): angular.IPromise<any> {
            var dataToPost = {
                "AccountId": this.account.accountId,
                "LocationLevelSubaccount": this.account.locationLevelSubaccount,
                "IncludeInactive": this.account.includeInactive,
                "YearThreshold": this.account.yearThreshold,
                "ObjectStateEnum": this.account.syncStatus ? Model.ObjectStateEnum.Active :
                    (this.savedAccount.syncStatus ? Model.ObjectStateEnum.Purged : Model.ObjectStateEnum.Exclude),
                "UserId": this.identityService.current().userId
            }
            
            return this.dataService.customMethodData("api/EmailMarketing/Account", "POST", dataToPost).then((res) => {

                if (res.data) {
                    this.modalService.message("MESSAGE_EMMA_ACCOUNT_ID_UPDATE_SUCCESS", ModalTranslationModes.Translate);
                    this.savedAccount = angular.copy(this.account);
                    this.mode = Meevo.Model.MaintenanceFormState.Readonly;
                    this.initDisplayOptions();
                }
                else {
                    this.modalService.alert("MESSAGE_EMMA_ACCOUNT_ID_UPDATE_ERROR", ModalTranslationModes.Translate);
                }
            });
        }
       
        cancel(): void {
            
            this.mode = Meevo.Model.MaintenanceFormState.Readonly;
            this.account = angular.copy(this.savedAccount);
            this.initDisplayOptions();
            this.previewCount = -1;
        }
        
        get isEditing(): boolean {
            return false;
        }

        get isReadonly(): boolean {
            return this.mode == Meevo.Model.MaintenanceFormState.Readonly;
        }

        get currentlyEditing(): boolean {
            return this.mode == Meevo.Model.MaintenanceFormState.Editing;
        }

        protected buildCrudSecurityKeys(baseKey, hasCreateKey = false, hasCopyKey = false, hasChangeAccessKey = false, hasChangeOwnerKey = false) {
            this.addSecurityKey = baseKey + ((hasCreateKey) ? Meevo.Components.Common.SecurityParts.KEY_PART_CREATE : Meevo.Components.Common.SecurityParts.KEY_PART_WRITE);
            this.editSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
            
        }

        usageTrackingLog(verbEnum, payload): void {
            if (Meevo.Model.NounEnum.AdvancedMarketing && Meevo.Model.NounEnum.AdvancedMarketing !== null) {
                var trackingItem = new Meevo.Model.TrackingItem(Meevo.Model.NounEnum.AdvancedMarketing, verbEnum, payload, null);
                this.trackingService.saveTrackingInfo(trackingItem);
            }
        }

        goToEmmaPortal(): void {
            this.window.open(this.advancedMarketingPortalUrl, '_blank');
        }

        public showRestrictedSettingsModal(): void {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/emmaAccountSettings/modals/emailMarketingRestrictedSettings.component.html',
                locals: {
                    account: this.account,
                    identityService: this.identityService
                },
                controller: 'meevo.plugins.emmaAccountSettings.EmailMarketingRestrictedSettingsController',
                controllerAs: '$ctrl',
                bindToController: true,
                hasBackdrop: true
            };

            this.modalService.showCustom(options, null, true).then((res) => {
                if (res) {
                    this.account = res;
                    
                    this.initDisplayOptions();
                    
                    var url = `api/EmailMarketing/ClientPreview?yearThreshold=${this.account.yearThreshold}&includeInactive=${this.account.includeInactive}`;
                    this.dataService.customMethodData(url, "GET", null).then((res) => {
                        this.previewCount = res.data;
                    });
                }
            });
            
            
        }

        getSyncNoteText(): string {
            return this.$translate.instant("LABEL_EMMA_SYNC_NOTE", { yearThreshold: this.account.yearThreshold });
        }

        showSyncOptions(): boolean {
            return this.identityService.current().isSingleLocation ||
                !(this.account.locationLevelSubaccount && this.identityService.inCentralOfficeMode());
        }

        showSubmitButton(): boolean {
            return this.securityChecker.hasSecurity(this.securityKeys.MARKETING_EMMA_EMMASMS +
                Meevo.Components.Common.SecurityParts.KEY_PART_READ);
        }

        isCanSubmit() {
            if (this.identityService.inCentralOfficeMode()) {
                return !this.account.locationLevelSubaccount;
            } else {
                return  this.account.locationLevelSubaccount || this.identityService.current().isSingleLocation;
            }
        }

        public openSubmitModal(event): void {
            event.stopPropagation();
            var modalOptions = this;
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/emmaAccountSettings/modals/emailMarketingSubmitModal.component.html',
                controller: 'meevo.plugins.emmaAccountSettings.EmailMarketingSubmitModalController',
                controllerAs: "vm",
                bindToController: true,
                escapeToClose: true,
                locals: {
                    options: modalOptions
                }
            }
            this.modalService.showCustom(options).then((res) => {
                this.account.isTFNVerificationSubmitted = res.data.isTFNVerificationSubmitted;
                this.account.dateTFNVerificationSubmitted = res.data.dateTFNVerificationSubmitted;
            });

            
        }

    }
}